"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZPerformedBySchema = exports.PerformedBySchema = exports.fromImport = exports.connect = exports.integration = exports.workflow = exports.key = exports.user = exports.toPublic = exports.PerformedByType = void 0;
const joi_1 = __importDefault(require("joi"));
const zod_1 = __importDefault(require("zod"));
const util_1 = require("../util");
var PerformedByType;
(function (PerformedByType) {
    PerformedByType["Key"] = "KEY";
    PerformedByType["User"] = "USER";
    PerformedByType["Workflow"] = "WORKFLOW";
    PerformedByType["Integration"] = "INTEGRATION";
    PerformedByType["Connect"] = "CONNECT";
    PerformedByType["Import"] = "IMPORT";
})(PerformedByType || (exports.PerformedByType = PerformedByType = {}));
const toPublic = (performedBy) => {
    if (performedBy == null) {
        return performedBy;
    }
    switch (performedBy.type) {
        case PerformedByType.User:
        case PerformedByType.Key: {
            return (0, util_1.omit)(performedBy, ['ip', 'requestId']);
        }
        default:
            return performedBy;
    }
};
exports.toPublic = toPublic;
const user = (id, options = {}) => {
    return {
        type: PerformedByType.User,
        id,
        ip: options.ip,
        requestId: options.requestId,
    };
};
exports.user = user;
const key = (id, options = {}) => {
    return {
        type: PerformedByType.Key,
        id,
        ip: options.ip,
        requestId: options.requestId,
    };
};
exports.key = key;
const workflow = (id) => {
    return {
        type: PerformedByType.Workflow,
        id,
    };
};
exports.workflow = workflow;
const integration = (id) => {
    return {
        type: PerformedByType.Integration,
        id,
    };
};
exports.integration = integration;
const connect = (id) => {
    return {
        type: PerformedByType.Connect,
        id,
    };
};
exports.connect = connect;
const fromImport = (id) => {
    return {
        type: PerformedByType.Import,
        id,
    };
};
exports.fromImport = fromImport;
exports.PerformedBySchema = joi_1.default.object({
    type: joi_1.default.string()
        .allow(...Object.values(PerformedByType))
        .required(),
    id: joi_1.default.string().uuid().required(),
    ip: joi_1.default.string().ip(),
    requestId: joi_1.default.string().uuid(),
});
exports.ZPerformedBySchema = zod_1.default.object({
    type: zod_1.default.nativeEnum(PerformedByType),
    id: zod_1.default.string().uuid(),
    ip: zod_1.default.string().ip().optional(),
    requestId: zod_1.default.string().uuid().optional(),
});
//# sourceMappingURL=index.js.map